import { render, staticRenderFns } from "./PropagandistStatisticsDetails.vue?vue&type=template&id=62776c92&"
import script from "./PropagandistStatisticsDetails.vue?vue&type=script&lang=js&"
export * from "./PropagandistStatisticsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports